import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../../icons'
import { Columns } from '../../layout'

/**
 * Displays a value with its unit. If value is a number, uses a [LocalizedNumber](#/Intl?id=localizednumber).
 */
const Measure = ({ children, unit, icon, ...domProps }) => {
  return children ? (
    <Columns layout="auto" align="baseline" gap=".25rem" {...domProps}>
      {icon && <Icon icon={icon} size="sm" />}
      <span>{children}</span>
      {unit ? <span>{unit}</span> : ''}
    </Columns>
  ) : (
    ''
  )
}

Measure.propTypes = {
  /**
   * The value to display as children
   */
  children: PropTypes.node,
  /**
   * The measure unit.
   */
  unit: PropTypes.node,
  /**
   * The icon to place before.
   */
  icon: PropTypes.any,
}

export default Measure
